import { Platform } from 'react-native';

/**
 * CORE-973 — CSS-анимации знака загрузки едут вместе с бандлом, а не из
 * `public/global.css`. Тот файл подключается отдельным <link> уже после старта
 * JS и в проде живёт по URL без версии: лоадер успевает показаться раньше, чем
 * приедут правила, а у вернувшегося посетителя браузер может отдать старую
 * копию. Правило, от которого зависит единственный кадр загрузки, не должно
 * зависеть от второго сетевого запроса.
 *
 * Сами анимации — transform и opacity: их считает композитор, а не JS-поток,
 * занятый в этот момент чанком маршрута. Ровно то, что на нативке даёт
 * useNativeDriver.
 */
const STYLE_ID = 'agp-loader-anim';

const CSS = `
@keyframes agp-loader-orbit {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}
@keyframes agp-loader-pulse {
  0%, 100% { opacity: 0.72; transform: scale(0.98); }
  50% { opacity: 1; transform: scale(1.025); }
}
@keyframes agp-loader-enter {
  from { opacity: 0; }
  to { opacity: 1; }
}
[data-agp-loader-orbit="true"] {
  transform-origin: center;
  will-change: transform;
  animation: agp-loader-orbit 2.8s linear infinite;
}
[data-agp-loader-pulse="true"] {
  transform-origin: center;
  will-change: transform, opacity;
  animation: agp-loader-pulse 2.4s ease-in-out infinite;
}
[data-agp-loader-enter="true"] {
  animation: agp-loader-enter 0.21s ease-out both;
}
/* «Уменьшить движение» не значит «замереть»: вращение здесь — единственный
   признак, что страница жива. Остаётся ровный медленный ход, уходят пульсация
   и масштабирование. Настройка включена у заметной доли посетителей Windows
   (Специальные возможности → Визуальные эффекты → Эффекты анимации), и для них
   знак раньше стоял неподвижно всю загрузку. */
@media (prefers-reduced-motion: reduce) {
  [data-agp-loader-orbit="true"] { animation-duration: 4.6s; }
  [data-agp-loader-pulse="true"],
  [data-agp-loader-enter="true"] { animation: none; }
}
`;

/** Идемпотентно; на нативке — no-op. */
export function ensureLoaderKeyframes() {
  if (Platform.OS !== 'web' || typeof document === 'undefined') return;
  if (document.getElementById(STYLE_ID)) return;
  const style = document.createElement('style');
  style.id = STYLE_ID;
  style.textContent = CSS;
  document.head.appendChild(style);
}
